import * as React from 'react'
import { InfoIcon } from 'lucide-react'
import { Timestamp } from '@klear/time'
import { cn } from '@klear/ui/lib/utils'

const CLOCK_FORMAT = 'M/D/YYYY h:mma'
const REFRESH_MS = 30_000

function utcDateNoticeText(now: Timestamp): string | undefined {
  if (now.toKlearDate().isSame(now.toLocalKlearDate())) return undefined
  return `Dates are recorded and calculated in UTC. It is currently ${now.toString(CLOCK_FORMAT)} in UTC, ${now.toLocalString(CLOCK_FORMAT)} local time, so today's date differs from yours.`
}

export function UtcDateNotice({ className }: { className?: string }) {
  const [text, setText] = React.useState(() => utcDateNoticeText(Timestamp.now()))

  React.useEffect(() => {
    const id = setInterval(() => setText(utcDateNoticeText(Timestamp.now())), REFRESH_MS)
    return () => clearInterval(id)
  }, [])

  if (text == null) return null

  return (
    <p className={cn('flex items-start gap-1.5 text-xs text-muted-foreground', className)}>
      <InfoIcon className="h-3.5 w-3.5 shrink-0 mt-0.5" />
      <span>{text}</span>
    </p>
  )
}
